import { ExportDataIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import {
  useGeneratePlaybookPDFMutation,
  useLazyGetPlaybookQuery,
} from "../../../../api";
import { CircularProgress } from "@mui/material";

export const ExportPlaybookBtn = ({
  member_id,
  onClose,
  btnHeight = "42px",
  btnPadding = "8px",
}: {
  member_id: string;
  campaign_id: string;
  onClose?: () => void;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [getPlaybook, { isFetching: isPlaybookLoading }] =
    useLazyGetPlaybookQuery();
  const [generatePlaybookPDF, { isLoading: isGeneratingPlaybookPDF }] =
    useGeneratePlaybookPDFMutation();

  const handleClose = () => {
    onClose && onClose();
  };

  const exportPlaybook = () => {
    getPlaybook({ member_id })
      .unwrap()
      .then((topics) => {
        generatePlaybookPDF({ member_id, topics })
          .unwrap()
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `SDR Playbook for ${topics.lead_company} - ${topics.lead_name}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
            handleClose();
          })
          .catch((err) => {
            toast.error(
              <CustomToast
                type={"error"}
                text={
                  getErrorMessage(err).globalError ||
                  "Something went wrong. Please try again"
                }
                title={"Failed to generate SDR Playbook PDF"}
              />,
            );
          });
      })
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            title="Something went wrong"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
          />,
        ),
      );
  };

  return (
    <CustomButton
      onClick={exportPlaybook}
      variant="outlined"
      customColor="#FFFFFF"
      textColor="#1D3E70"
      type="button"
      customSize="fit"
      style={{ padding: btnPadding }}
      sx={{
        borderColor: "#1D3E70",
        minWidth: "fit-content",
        height: btnHeight,
      }}
      disabled={isPlaybookLoading || isGeneratingPlaybookPDF}
    >
      {isPlaybookLoading || isGeneratingPlaybookPDF ? (
        <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
      ) : (
        <ExportDataIcon />
      )}
    </CustomButton>
  );
};
